import { render, staticRenderFns } from "./GeraLink.vue?vue&type=template&id=0c0a4799"
import script from "./GeraLink.vue?vue&type=script&lang=js"
export * from "./GeraLink.vue?vue&type=script&lang=js"
import style0 from "./GeraLink.vue?vue&type=style&index=0&id=0c0a4799&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports